import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["viewBox"]
const _hoisted_2 = {
  id: "Frame",
  "clip-path": "url(#clip0_580_4347)"
}
const _hoisted_3 = ["fill"]
const _hoisted_4 = { id: "clip0_580_4347" }
const _hoisted_5 = ["fill"]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'clockIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#000000",
  },
  size: {
    type: Number as PropType<number>,
    default: 20,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    style: _normalizeStyle(`max-width: ${__props.size}px; max-height: ${__props.size}px; min-width: ${__props.size}px; min-height: ${__props.size}px; display: flex; align-items: center;`)
  }, [
    (_openBlock(), _createElementBlock("svg", {
      style: {"width":"100%","height":"100%"},
      viewBox: `0 0 ${__props.size} ${__props.size}`,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      _createElementVNode("g", _hoisted_2, [
        _createElementVNode("path", {
          id: "Vector",
          d: "M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433286 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0ZM14.3333 14.35C14.2592 14.4315 14.1697 14.4974 14.0699 14.5441C13.9702 14.5907 13.8621 14.6172 13.7521 14.6218C13.6421 14.6265 13.5322 14.6093 13.4288 14.5712C13.3255 14.5331 13.2307 14.4749 13.15 14.4L8.98334 10.6167C8.90454 10.5352 8.84321 10.4384 8.80309 10.3324C8.76297 10.2264 8.74491 10.1133 8.75 10V5.41667C8.75 5.19565 8.8378 4.98369 8.99408 4.82741C9.15036 4.67113 9.36232 4.58333 9.58334 4.58333C9.80435 4.58333 10.0163 4.67113 10.1726 4.82741C10.3289 4.98369 10.4167 5.19565 10.4167 5.41667V9.63333L14.275 13.175C14.4382 13.3233 14.536 13.5302 14.5469 13.7504C14.5579 13.9707 14.4811 14.1863 14.3333 14.35Z",
          fill: __props.color
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("defs", null, [
        _createElementVNode("clipPath", _hoisted_4, [
          _createElementVNode("rect", {
            style: _normalizeStyle(`width: ${__props.size}px;height: ${__props.size}px;`),
            fill: __props.color
          }, null, 12, _hoisted_5)
        ])
      ])
    ], 8, _hoisted_1))
  ], 4))
}
}

})